import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Modal } from "@mui/material";
import "./index.css";
import { useWeb3Auth } from "../../hooks/useWeb3Auth";
import { useTranslation } from "react-i18next";
import { getProticoClient, API_GET_USER_SUPERCHAT } from "../../utils/api";
import { theme } from "../../const";
interface IProps {
  isOpen?: boolean;
  setIsOpen: any;
}
const SuperChatHistoryAction: React.FC<IProps> = ({ isOpen, setIsOpen }) => {
  const [messages, setMessages] = useState<any[]>([]);
  const [superChatLoading, setSuperChatLoading] = useState<boolean>(false);

  const { t } = useTranslation();

  const { isProticoAuthenticated, address, logout, proticoAuthenticate } =
    useWeb3Auth();
  const onAuthentucateClick = async () => {
    await proticoAuthenticate();
  };
  const handleLogout = async () => {
    setIsOpen(false);
    await logout();
  };
  const formatTimestamp = (timestamp: any) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
  };
  const getTypeClass = (type: string) => {
    if (type === "Cash") {
      return "superchat-message-cash";
    }
    return "superchat-message-points";
  };
  useEffect(() => {
    const fetchSuperChatHistory = async () => {
      if (isProticoAuthenticated && address) {
        try {
          setSuperChatLoading(true);
          const response = await getProticoClient().api.get(
            API_GET_USER_SUPERCHAT
          );
          // Assuming the response data is an array of messages
          setMessages(response.data);
          setSuperChatLoading(false);
        } catch (error) {
          setSuperChatLoading(false);
          console.error("Error fetching super chat history:", error);
        }
      }
    };
    fetchSuperChatHistory();
  }, [isProticoAuthenticated, address]);
  return (
    <Modal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      style={{
        border: "1px solid #333",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "275px",
        height: "375px",
        margin: "auto",
        borderRadius: "10px",
        color: "white",
      }}
    >
      <div className="superchat-history-container">
        {isProticoAuthenticated ? (
          <div className="superchat-history-main-container">
            <div className="superchat-message-container">
              <div className="superchat-message-header">
                <h2>{t("SuperChat_Record_Title")}</h2>
              </div>
              {superChatLoading ? (
                <div style={{ margin: "auto" }}>
                  <CircularProgress
                    style={{ color: theme.brandColor }}
                    size={20}
                  />
                </div>
              ) : messages.length === 0 ? (
                <div className="superchat-no-messages">
                  <p>{t("No_SuperChat_Messages")}</p>
                </div>
              ) : (
                <div className="superchat-message-list">
                  {messages.map((msg: any) => (
                    <div
                      key={msg.id}
                      className={`superchat-message-card ${getTypeClass(
                        msg.super_chat_type
                      )}`}
                    >
                      <div className="superchat-message-content">
                        {t("SuperChat_Record_Content")}
                        <br/>
                        <p className="superchat-content-text">{msg.messageText}</p>
                      </div>

                      <div className="superchat-message-meta">
                        <div className="superchat-list-points">
                          {t("SuperChat_Record_Target")}
                          <a
                            href={msg.room}
                            target="_blank"
                            className="superchat-room-tag"
                          >
                            <span className="superchat-room-url">{msg.room}</span>
                          </a>
                        </div>
                      </div>
                      <div className="superchat-message-meta">
                        <div className="superchat-list-points">
                          {t("SuperChat_Record_Currency")}
                          {msg.point}{" "}
                          {msg.super_chat_type === "Cash" ? "TWD" : "Points"}
                        </div>
                      </div>
                      <div className="superchat-message-footer">
                        <div>
                          {t("SuperChat_Record_Timestamp") + formatTimestamp(msg.createdAt)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ) : !address ? (
          <div className="superchat-message-container">
            <div className="superchat-record-login-reminder">
              <p style={{ marginBottom: "1.5rem", lineHeight: "1.5rem" }}>{t("SuperChat_Record_Intro")}</p>
              <Button onClick={() => handleLogout()} variant="outlined">
                {t("First_Message_Login_Button")}
              </Button>
            </div>
          </div>
        ) : (
          <div className="superchat-message-container">
            <div className="superchat-record-login-reminder">
              <p style={{ marginBottom: "1.5rem", lineHeight: "1.5rem" }}>{t("SuperChat_Record_Intro")}</p>
              <Button onClick={() => onAuthentucateClick()} variant="outlined">
                {t("PIN_Signin_Verify_Wallet")}
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SuperChatHistoryAction;
